import styled from 'styled-components';

export const HCPCSWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  padding-bottom: 20px;
`;
export const FlexGapDiv = styled.div<{
  hide?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  ${(props) =>
    props.hide
      ? `display: none;
         visibility: hidden;`
      : ``}
`;
export const AddICDDiv = styled.div<{
  hide?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  padding-left: 30px;
`;

export const ICDTitle = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  align-self: flex-start;
  font-weight: 600;
`;
export const RecordHCPCSDiv = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;
export const SubmitHCPCSDiv = styled.div<{
  record?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  ${(props) =>
    props.record ? `justify-content: flex-end;` : `justify-content: center;`}
`;
export const ICDDescription = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  flex-wrap: wrap;
`;
export const HCPCSMainDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
export const FullWidthDiv = styled.div`
  width: 100%;
`;

export const HCPCSTitle = styled.div`
  font-weight: 600;
`;

export const ICDContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
`;

export const MenuDiv = styled.div<{
  color?: string;
}>`
  ${(props) =>
    props.color
      ? `color: ${(props.theme.palette as any).hcpcsMenu[props.color]};`
      : ``}
`;
